import getVWKey from "../helpers/getVWKey";
import SlideManager from "./slide-manager";
import Network from "../miniviews/network";
import RenderManager from "../rendering/render-manager";
import CameraTweenTrack from "../camera/camera-tween-track";

function resetObjectPosition() {
    CameraTweenTrack.finishTweens();
    
    const vpType = getVWKey();
    const currentSlide = SlideManager.currentSlide;

    Object.keys(currentSlide.animation).forEach(objectUuid => {
        if (!Q3.data.assets.objects[objectUuid]) return;

        const mesh = Q3.assets.objects[objectUuid];
        const currAnimation = currentSlide.animation[objectUuid];
        const currCameraData = vpType === "sizeSm" && currAnimation[vpType]
            ? currAnimation[vpType]
            : currAnimation;

        mesh.position.copy(currCameraData.position);
        mesh.scale.copy(currCameraData.scale);
        mesh.rotation.x = currCameraData.rotation.x;
        mesh.rotation.y = currCameraData.rotation.y;
        mesh.rotation.z = currCameraData.rotation.z;
    });

    const slideQuiz = SlideManager.currentSlide.slideQuiz;

    if (slideQuiz && slideQuiz.type === "plopQuiz") {
        (Q3.editMode ? slideQuiz.meshes : slideQuiz.assessments)
            .forEach(ass => {
                const matrix = ass.getCurrentInitialMatrix(vpType);
                const plop = ass.plopObject;

                matrix.decompose(plop.position, plop.quaternion, plop.scale);
            });
    }

    RenderManager.activeCamera.update = true;
}

export default resetObjectPosition;
export { resetObjectPosition };